export const USERS_MAP = {
  ftrobo: {
    companyName: '富蘭克林投顧',
  },
  richart: {
    companyName: '台新Richart',
  },
  huanan: {
    companyName: '華南銀行'
  }
};

// Old HOST keep it for reference
// export const HOST =
//   (process.env.REACT_APP_ENV === 'development' ||
//   process.env.REACT_APP_ENV === 'preview')
//     ? 'http://api.leadinfo.com.tw'
//     : 'https://api.tradingvalley.com';

export const HOST = 'https://www.tradingvalley.tw/api';

export const EX_DB = process.env.REACT_APP_ENV === 'production' ? 'yes' : 'no';




// WEBPACK FOOTER //
// ./src/constant/index.js